import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxUploaderModule } from "ngx-uploader";
import { SvgIconModule } from "../svg-icon/svg-icon.module";
import { FileUploadComponent } from "./file-upload.component";

@NgModule({
    imports: [CommonModule, SvgIconModule, NgxUploaderModule],
    exports: [FileUploadComponent],
    declarations: [FileUploadComponent],
})
export class FileUploadModule {}
